import { isAfter, isBefore } from "date-fns";

import { POLICY_CONST } from "../../../constants";

import type { Term, PolicyState } from "../../../store/types/policy";

// gets the current term based on a few conditions and returns it
export const getCurrentTerm = (
  terms: Term[],
  policyState: PolicyState
): Term => {
  // If there are terms, extract the dates from them
  if (terms?.length) {
    let currentTerm = terms[0];
    const today = new Date();
    const isCancelled =
      policyState.value === POLICY_CONST.POLICY_STATES.CANCELLED;

    if (terms.length !== 1) {
      // more than one term?
      // use the last term with a past effective date
      // i.e. loop through each term - if the effective date is in the past, set it
      terms.forEach(term => {
        const termEffectiveDate = new Date(term.EffectiveDate);

        if (
          // if it's cancelled, and the cancellation date is after the term effective date, this could be the current term
          (isCancelled &&
            isAfter(new Date(policyState.effectiveDate), termEffectiveDate)) ||
          // also if it's not cancelled, and the term effective date is before today (has past), this could be the current term
          (!isCancelled && isBefore(termEffectiveDate, today))
        ) {
          currentTerm = term;
        }
      });
    }
    return currentTerm;
  }
};
